'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.StringOrReact = exports.StringOrNumber = exports.isEventOutside = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Is event triggered outside DOM
var isEventOutside = exports.isEventOutside = function isEventOutside(e, dom) {
	var current = e.target;

	var componentNode = dom;

	while (current.parentNode) {
		if (current === componentNode) {
			return false;
		}
		current = current.parentNode;
	}

	if (current !== document) {
		return false;
	}

	return true;
};

var StringOrNumber = exports.StringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
var StringOrReact = exports.StringOrReact = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]);